<template>
  <el-dialog
    title="跟进记录"
    :visible.sync="dialogVisible"
    width="1200px"
    @close="handleClose"
    destroy-on-close
  >
    <!-- 客户信息 -->
    <div class="follow-up-info" v-if="orderInfo && orderInfo.orderNo">
      <div class="info-item">
        <span class="label">客户姓名：</span>
        <span>{{ orderInfo ? orderInfo.memberName : "" }}</span>
      </div>
      <div class="info-item">
        <span class="label">手机号：</span>
        <span>{{ orderInfo ? orderInfo.memberMobile : "" }}</span>
      </div>
      <div class="info-item">
        <span class="label">订单号：</span>
        <span>{{ orderInfo ? orderInfo.orderNo : "" }}</span>
      </div>
    </div>

    <!-- 历史跟进记录 -->
    <tp-table
      :isNeedSerialNumber="true"
      :tableData="recordList"
      :columns="recordColumns"
      :showPagination="false"
      :maxHeight="250"
    />

    <!-- 添加跟进记录 -->
    <div class="add-record-section" v-if="showAddForm">
      <el-divider>添加跟进记录</el-divider>
      <el-form ref="form" :model="formData" label-width="120px">
        <el-form-item
          label="跟进记录"
          prop="content"
          :rules="[
            { required: true, message: '请输入跟进记录', trigger: 'blur' },
          ]"
        >
          <el-input
            type="textarea"
            :rows="4"
            v-model="formData.content"
            placeholder="请输入跟进记录"
          ></el-input>
        </el-form-item>
        <el-form-item label="下次跟进日期" prop="nextFollowUpDate">
          <el-date-picker
            v-model="formData.nextFollowUpDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button v-if="showAddForm" type="primary" @click="handleSubmit">
        {{ submitButtonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getFollowUpRecordListAPI,
  addFollowUpRecordAPI,
} from "../api/follow-up";

const recordColumns = [
  {
    label: "跟进人",
    prop: "followUserName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["followUserName"] || ""}</p>;
    },
  },
  {
    label: "跟进记录",
    prop: "content",
    minWidth: "300",
    customRender(h, row) {
      return <p>{row["content"] || ""}</p>;
    },
  },
  {
    label: "下次跟进日期",
    prop: "nextFollowDate",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["nextFollowDate"] || ""}</p>;
    },
  },
  {
    label: "跟进时间",
    prop: "followTime",
    minWidth: "180",
    customRender(h, row) {
      return <p>{row["followTime"] || ""}</p>;
    },
  },
];

export default {
  name: "FollowUpRecord",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderInfo: {
      type: Object,
      default: () => ({}),
    },
    // 是否显示添加表单
    showAddForm: {
      type: Boolean,
      default: true,
    },
    // 提交按钮文本
    submitButtonText: {
      type: String,
      default: "提交",
    },
    // 是否在提交后自动完成跟进
    autoComplete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible || false,
      recordColumns,
      recordList: [], // 跟进记录列表
      formData: {
        content: "",
        nextFollowUpDate: "",
      },
      // 日期选择器配置：只能选择今天之后的日期
      pickerOptions: {
        disabledDate(time) {
          // 获取今天的开始时间（00:00:00）
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          // 禁用今天及之前的日期
          return time.getTime() <= today.getTime();
        },
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetForm();
        this.getRecordList();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    async getRecordList() {
      const res = await getFollowUpRecordListAPI({
        orderNo: this.orderInfo.orderNo,
      });

      this.recordList = res.followList || [];
    },
    resetForm() {
      this.formData = {
        content: "",
        nextFollowUpDate: "",
      };
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    async handleSubmit() {
      await this.$refs.form.validate();

      await addFollowUpRecordAPI({
        orderNo: this.orderInfo.orderNo,
        content: this.formData.content,
        nextFollowDate: this.formData.nextFollowUpDate || "",
      });

      this.$message.success("跟进记录添加成功");

      this.resetForm();

      this.getRecordList();

      this.$emit("success", {
        content: this.formData.content,
        nextFollowUpDate: this.formData.nextFollowUpDate,
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-up-info {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;

  .info-item {
    font-size: 14px;

    .label {
      font-weight: 600;
      color: #606266;
    }
  }
}

.add-record-section {
  margin-top: 20px;
}
</style>
